import { render, staticRenderFns } from "./CancellationReproved.vue?vue&type=template&id=b13b8f18&"
import script from "./CancellationReproved.vue?vue&type=script&lang=js&"
export * from "./CancellationReproved.vue?vue&type=script&lang=js&"
import style0 from "./CancellationReproved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CancellationReproved.vue"
export default component.exports